<template>

  <!-- <NavBar /> -->

  <q-page 
    id="site-container">
    
    <!-- 메인영역 -->
    <Main />

    <!-- 서비스 영역 -->
    <Services />

    <!-- 스케쥴표 영역 -->
    <Schedule />
    
    <!-- Calculator -->
    <Calculator />

  </q-page>
  <!-- <Footer></Footer> -->
</template>

<script>
import Main from "@/components/customer/home/Section01.vue"
import Services from "@/components/customer/home/Services.vue"
import Schedule from "@/components/customer/home/Schedule.vue"
import Calculator from "@/components/customer/home/Calculator.vue"

export default {
  name: "HomePage",
  components: {
    Main,
    Services,
    Schedule,
    Calculator
  },
  methods:{
    moveTo(destination){
      this.$router.push(destination)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
